import { getProductByIdThunk } from './productThunks/index';
import { type IProduct } from '../../types/IProduct';
import { type IErrorData } from '../../utils/getErrorData';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export interface IProductState {
  product: IProduct | null;
  shouldShowOffersModal: boolean;
  isProductLoading: boolean;
  errorProduct: IErrorData | null;
}

const initialState: IProductState = {
  product: null,
  shouldShowOffersModal: false,
  isProductLoading: false,
  errorProduct: null
};

const product = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProduct (state, action: PayloadAction<IProduct | null>) {
      state.product = action.payload;
    },
    setShouldShowOffersModal (state, action: PayloadAction<boolean>) {
      state.shouldShowOffersModal = action.payload;
    },
    resetProduct (state) {
      state.shouldShowOffersModal = initialState.shouldShowOffersModal;
      state.product = initialState.product;
      state.isProductLoading = initialState.isProductLoading;
      state.errorProduct = initialState.errorProduct;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getProductByIdThunk.fulfilled, (state, action) => {
      state.product = action.payload;
      state.isProductLoading = false;
      state.errorProduct = null;
    });

    builder.addCase(getProductByIdThunk.pending, (state) => {
      state.errorProduct = null;
      state.isProductLoading = true;
    });

    builder.addCase(getProductByIdThunk.rejected, (state, action) => {
      state.errorProduct = action.payload ?? {
        message: 'Произошла необработанная ошибка при получении товара'
      };
      state.isProductLoading = false;
      if (typeof state.errorProduct?.message === 'string') {
        toast.error(state.errorProduct?.message);
      }
    });
  }
});

export const { setProduct, resetProduct, setShouldShowOffersModal } =
  product.actions;

export default product.reducer;
